import React from "react";
import Image from "next/image";
import { ABOUT_US_KOL_LIST } from "@/cdn-resources";
const KOLVideo = () => {
  return (
    <div className="mb-[100px]">
      <h2 className="text-[42px] w-[762px] text-center mt-[10px] mb-[60px] mx-auto font-semibold">
        Stop wasting time searching for the right KOL.
      </h2>
      <div className="flex justify-center gap-[40px] mt-[40px]">
        {ABOUT_US_KOL_LIST.map((src) => {
          return (
            <div
              key={src}
              className="p-[6px] bg-white rounded-[20px] shadow-lg"
            >
              <Image src={src} alt="kol" width={258} height={408} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default KOLVideo;
